<template>
  <second-page
    :asideTitle="asideTitle"
    :title="title"
    :currPrograma="currPrograma"
    :asideList="asideList"
    :currType="currType"
    :currPath="currPath"
    :routeKeepAlive="routeKeepAlive"
    :routeKeepChild="routeKeepChild"
    @titleChange="titleChange"
    @currProgramaChange="currProgramaChange"
    @currTypeChange="currTypeChange"
  ></second-page>
</template>
<script>
import SecondPage from '../../components/SecondPage/index.vue'
import { getOrganizations } from '@/api/api'
export default {
  name: 'department',
  components: {
    SecondPage,
  },
  data() {
    return {
      asideTitle: '部门机构',
      title: '',
      currPrograma: '',
      asideList: [
        {
          id: 0,
          title: '部门概况',
          child: [
            // { id: 0, title: '发展史', showType: 'article' },
            // { id: 1, title: '主要工作', showType: 'list' },
          ],
          showType: 'article',
        },
        {
          id: 1,
          title: '部门领导',
          child: [
            // { id: 0, title: '领导信息', showType: 'image' },
            // { id: 1, title: '主要工作', showType: 'list' },
          ],
          showType: 'image',
        },
        {
          id: 2,
          title: '组织机构',
          child: [
            { id: 0, title: '体育教研室', showType: 'table' },
            { id: 1, title: '美育教研室', showType: 'table' },
            { id: 2, title: '艺术教研室', showType: 'table' },
            { id: 3, title: '综合办公室', showType: 'table' },
          ],
          showType: '',
        },
      ],
      currType: 'image',
      currPath: '/department',
      routeKeepAlive: '',
      routeKeepChild: '',
    }
  },
  created() {
    this.getDepartment()
    this.routeKeepAlive = this.$route.query.keepalive
    this.routeKeepChild = this.$route.query.keepchild

    // this.title = this.asideList[0].title
    // if (this.asideList[0].child.length > 0) {
    //   this.currPrograma = this.asideList[0].child[0].title
    //   this.currType = this.asideList[0].child[0].showType
    // } else {
    //   this.currPrograma = ''
    //   this.currType = this.asideList[0].showType
    // }
  },
  methods: {
    // changeBread(two, three) {
    //   this.title = two
    //   this.currPrograma = three
    //   console.log('two:', two)
    //   console.log('three:', three)
    // },
    // changeType(type) {
    //   this.currType = type
    // },
    getDepartment() {
      //   getDepartment().then((res) => {
      //     console.log(res)
      //   })
      getOrganizations().then((res) => {
        if (res.data.statusCode == 1) {
          res.data.obj.forEach((item) => {
            this.$set(item, 'showType', 'table')
          })
          this.asideList[2].child = res.data.obj
        }
      })
    },
    titleChange(currVal) {
      this.title = currVal
    },
    currProgramaChange(currVal) {
      this.currPrograma = currVal
    },
    currTypeChange(currVal) {
      this.currType = currVal
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
</style>
